import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { generateOTPApi, verifyOTPApi } from "../../services/auth";
import OtpInput from "../totpInput";

export type Props = {
  handleNext: () => void;
  username: string;
};

const OTP = (props: Props) => {
  const [otp, setOtp] = useState("");
  const onChange = (value: string) => setOtp(value);
  const [count, setCount] = useState(1);
  let navigate = useNavigate();

  useEffect(() => {
    const sendVerificationOTP = async () => {
      const response = await generateOTPApi(props.username);
      if (response.status === 200) {
        toast.success("OTP Code has been sent to the registered mobile phone")
      }
    };
    sendVerificationOTP();
  }, []);

  const handleSubmit = async () => {
    if (otp.length < 6) {
      toast.error("Please fill in all fields");
    }

    try {
      const formData = new FormData();
      formData.append("otpVerify", otp);
      formData.append("attempts", count.toString());
      formData.append("username", props.username);
      const response = await verifyOTPApi(formData);
      if (response.status === 200) {
        props.handleNext();
      }
    } catch (e) {
      if (e instanceof AxiosError && e.response && e.response.status === 403) {
        setCount((count) => count + 1);
        if (count >= 3) {
          navigate("/login");
          toast.error(
            "You have used up your number of attempts. Please try again."
          );
        }
      }
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t my-8">
              <h3 className="text-3xl font-semibold">
                Please Enter the OTP to Verify Account
              </h3>
            </div>
            {/*body*/}
            <div className="container mx-auto">
              <div className="max-w-sm mx-auto md:max-w-lg">
                <div className="w-full">
                  <div className="bg-white h-64 py-3 rounded text-center">
                    <div className="flex flex-col mt-4">
                      <span>
                        A OTP(one time Password) has been send to your phone
                        number
                      </span>
                    </div>
                    <OtpInput value={otp} valueLength={6} onChange={onChange} />
                  </div>
                </div>
              </div>
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                type="button"
                onClick={() => handleSubmit()}
              >
                Verify Account
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OTP;
